(ns frontend.view.components.form.components.form-account
  (:require
   [frontend.bootstrap.components :as rbs]
   [frontend.utils :as fu]))

(defn account-circle
  [{:keys [account is-modal? center-block? classes]}]
  (let [{:keys [account/first-name account/last-name account/picture-url]} account
        picture-url (fu/only-https-or-relative-img picture-url)]
    (if picture-url
      [rbs/Image
       {:alt            (str " " (first first-name) (first last-name))
        :src            (fu/sanitize-img-url picture-url)
        :fluid          "fluid"
        :class-name     (str (:image classes)
                             (when center-block?
                               " center-block")
                             (when-not is-modal?
                               " form__account__circle__main"))
        :rounded-circle true}]

      (str (first first-name) (first last-name)))))

;; for fields that are not deal-owner
(defn account-rectangle
  [{:keys [account clickable? hide-name? classes stretch?]}]
  (let [{:keys [account/first-name account/last-name account/picture-url]} account
        picture-url (fu/only-https-or-relative-img picture-url)]
    [:div
     (if picture-url
       [rbs/Image
        {:alt        (str " " (first first-name) (first last-name))
         :src        (fu/sanitize-img-url picture-url)
         :class-name (fu/cs "form__account__rectangle__image"
                            (:image classes))
         :rounded-circle true}]
       [:div
        {:class-name (str "form__account__rectangle__image-text "
                          (:text classes))}
        (if (or first-name last-name)
          (str (first first-name) (first last-name))
          [:i.fal.fa-plus])])
     (when-not hide-name?
       [:div.form__account__rectangle__name
        [:span
         first-name]
        [:span last-name]])]))
